angular.module('zc.zenclerkS')
  .controller('ZcsInvoiceEditController', ZcsInvoiceEditController);

ZcsInvoiceEditController.$inject = ['$scope', '$stateParams', '$translate', 'InvoiceAdjustment', 'adjustments', 'month', 'project'];
function ZcsInvoiceEditController($scope, $stateParams, $translate, InvoiceAdjustment, adjustments, month, project) {
  const vm = this;
  vm.project = project;
  vm.adjustments = adjustments;
  vm.showCreateView = month.isSameOrAfter(Date.now(), 'month');
  vm.newAdjustment = {};
  vm.discountTypeOptions = {
    normal: $translate.instant('sites.invoices.edit.invoice.edit.tsuujou'),
    agency: $translate.instant('sites.invoices.edit.invoice.edit.dairiten_mochi'),
    emin: $translate.instant('sites.invoices.edit.invoice.edit.appier_mochi'),
    agency_emin: $translate.instant('sites.invoices.edit.invoice.edit.dairiten_to_emin_ga'),
  };
  vm.adjustmentNameOptions = [
    {name: 'initial', title: $translate.instant('sites.invoices.edit.invoice.edit.shoki_hiyou')},
    {name: 'initial_discount', title: $translate.instant('sites.invoices.edit.invoice.edit.shoki_hiyou_waribiki')},
    {name: 'minimal_discount', title: $translate.instant('sites.invoices.edit.invoice.edit.saitei_riyouryou_waribiki')},
    {name: 'nullify_minimum_charge', title: $translate.instant('sites.invoices.edit.invoice.edit.minimamuchaaji_nashi')},
    {name: 'monthly_percent_discount', title: $translate.instant('sites.invoices.edit.invoice.edit.maitsuki_teiritsu_waribiki')},
    {name: 'other', title: $translate.instant('sites.invoices.edit.invoice.edit.sonohoka_hiyou')},
    {name: 'other_discount', title: $translate.instant('sites.invoices.edit.invoice.edit.sonohoka_waribiki')}
  ];
  vm.createInvoiceAdjustment = createInvoiceAdjustment;
  vm.removeInvoiceAdjustment = removeInvoiceAdjustment;
  vm.name = 'unknown';

  $scope.$watch('vm.newAdjustment.adjustment_name', () => {
    const obj = _.find(vm.adjustmentNameOptions, { name: vm.newAdjustment.adjustment_name });
    if(!obj) {
      return;
    }
    vm.newAdjustment.title = obj.title;
  });

  function refreshInvoiceAdjustment() {
    InvoiceAdjustment.show(project, $stateParams.term)
      .then(refreshAdjustments => {
        vm.adjustments = refreshAdjustments;
      });
  }

  function createInvoiceAdjustment() {
    vm.newAdjustment.adjustment_for = month.toDate();
    if(['initial_discount', 'minimal_discount', 'other_discount'].includes(vm.newAdjustment.adjustment_name)) {
      vm.newAdjustment.price = vm.newAdjustment.price * -1;
    }
    return InvoiceAdjustment.create(project, vm.newAdjustment)
      .then(createdAdjustments => {
        vm.newAdjustment = {};
        refreshInvoiceAdjustment();
      });
  }


  function removeInvoiceAdjustment(id) {
    InvoiceAdjustment.remove(project, id)
      .then(removedAdjustments => {
        vm.newAdjustment = {};
        refreshInvoiceAdjustment();
      });
  }

}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/invoices/edit/invoice_edit.controller.js